import { OnboardingCompanyProgress } from 'constants/OnboardingCompanyProgress';
import DashboardEmployeeTile from 'modules/dashboard/tiles/employees/DashboardEmployeeTile';
import OnboardingTile from 'modules/dashboard/tiles/onboarding-tile/OnboardingTile';
import { useState } from 'react';
import { useAppDispatch } from 'store';
import { changeCompaniesAction } from 'store/actions/auth-actions';
import { agreeAndConfirmCollaborationAction } from 'store/actions/company-onboarding-actions';
import { IEmployeeTotals } from 'types/employee';
import CollaborationAgreementModal from './CollaborationAgreementModal';
import { EmployeeContainer, OnboardingDashboardBackgroundImage, OnboardingDashboardContainer } from './styles';

const OnboardingManagerDashboard: React.FC<{
  companyIdNumber: number;
  companyId: number;
  onboardingProgress: OnboardingCompanyProgress;
  employeesCount: IEmployeeTotals;
}> = ({ companyIdNumber, onboardingProgress, employeesCount, companyId }) => {
  const dispatch = useAppDispatch();

  const [openAgreementModal, setOpenAgreementModal] = useState(false);

  const handleOpenAgreementModal = () => {
    setOpenAgreementModal(true);
  };

  const onApproveAgreement = () => {
    dispatch(agreeAndConfirmCollaborationAction({ companyIdNumber })).then(response => {
      setOpenAgreementModal(false);
      if (response.payload) {
        dispatch(changeCompaniesAction(+response.payload));
      }
    });
  };

  return (
    <OnboardingDashboardContainer>
      <OnboardingDashboardBackgroundImage />
      <OnboardingTile handleOpenAgreementModal={handleOpenAgreementModal} onboardingProgress={onboardingProgress} />
      {onboardingProgress === OnboardingCompanyProgress.AWAITING_APPROVAL && (
        <EmployeeContainer>
          <DashboardEmployeeTile
            employeesInvited={employeesCount ? employeesCount.invited : 0}
            employeesReady={employeesCount ? employeesCount.ready : 0}
            employeesDeployed={employeesCount ? employeesCount.deployed : 0}
            companyId={companyId}
          />
        </EmployeeContainer>
      )}
      {openAgreementModal && (
        <CollaborationAgreementModal onClose={() => setOpenAgreementModal(false)} onApprove={onApproveAgreement} />
      )}
    </OnboardingDashboardContainer>
  );
};

export default OnboardingManagerDashboard;
